<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.dashboardData"></CardLoading>
    <div id="mix-charts-overview" class="dashboard__card-content" :class="{ 'loadingBlur': loaders.dashboardData }" v-cloak>
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Hearing Aid Purchase Activity</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--sales"><i class="fa fa-chart-line"></i></div>
      </div>
      <div class="row dashboard__card-body dashboard__card-body--bordered">
        <div class="dashboard__grid dash-hearing-aid-activity__content-container" v-cloak>
          <div class="col-lg-9 col-md-12 dash-hearing-aid-activity__content-charts">
            <OverviewMixChart></OverviewMixChart>
          </div>
          <div class="col-lg-3 dashboard__card-body-col dashboard__card-body-col--shaded dash-hearing-aid-activity__overview-filters">
            <div class="card-block">
              <Filters filters-shown="['salesRange']"></Filters>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link">
          <router-link to="/purchase-activity" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import OverviewMixChart from '../purchase-activity/OverviewMixChart.vue';
  import Filters from '../purchase-activity/Filters.vue';
  import CardLoading from './CardLoading.vue';

  export default {
    name: 'PurchaseActivityCard',
    components: {
      OverviewMixChart,
      Filters,
      CardLoading,
    },
    computed: {
      ...mapGetters('purchaseActivity', ['loaders']),
    },
  };
</script>
